module.exports = __webpack_public_path__ + "img/moukunting.06f05863.jpeg";